import * as React from "react";
import TopBar from "@src/Components/Ui/TopBar/TopBar";
import Content from "@src/Components/Pages/Main/Content/Content";
import { STContentWrapper, STGridContent } from "./styles";
import { observable } from "mobx";
import { observer, inject } from "mobx-react";
import { Grid } from "@material-ui/core";
import MenuList from "./MenuList/MenuList";
import SideMenu from "@src/Components/Common/SideMenu/SideMenu";
import { IAuthStore } from "@src/Stores/Auth/types";
import { IValuesStore } from "@src/Stores/Values/types";
import WebSocketsProxy from "@src/Tools/WebSocketsProxy";
import { IThemesStore } from "@src/Stores/Themes/types";
import { RouterStore } from "mobx-react-router";
import { IManagementStore } from "@src/Stores/Management/types";

interface IProps {
  auth?: IAuthStore;
  values?: IValuesStore;
  themes?: IThemesStore;
  management?: IManagementStore;
  routing?: RouterStore;
}

@inject("auth", "values", "themes", "management", "routing")
@observer
class Main extends React.Component<IProps> {
  @observable drawerOpened: boolean = false;
  private webSocketsProxy = new WebSocketsProxy();

  handleDrawerToggle = () => {
    this.drawerOpened = !this.drawerOpened;
  };

  async componentDidMount() {
    if (await this.props.management.checkIsSynchronizationRunning()) {
      this.props.routing.history.push("/synchronization");
    }
    this.webSocketsProxy.start();
    await this.props.themes.getCurrentTheme(this.props.values.themeTypes.Application);
  }

  componentWillUnmount() {
    this.webSocketsProxy.stop();
  }

  render() {
    return (
      <React.Fragment>
        <Grid container direction="column">
          <TopBar onDrawerToggle={this.handleDrawerToggle} />
          <Grid item container wrap="nowrap">
            <Grid item>
              <SideMenu
                drawerOpened={this.drawerOpened}
                onDrawerToggle={this.handleDrawerToggle}
                menuListComponent={MenuList}
              />
            </Grid>
            <STGridContent>
              <STContentWrapper>
                <Content />
              </STContentWrapper>
            </STGridContent>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}
export default Main;
